/**
 * Render the managing operator (Key Account Manager) for display.
 *
 * Prefers the operator's real display name from smarta-accounts
 * (`assigneeDisplayName`), falling back to the email's local part when only the
 * email is available, and `-` when unassigned.
 */
export const formatAssignee = (
  displayName?: string | null,
  email?: string | null
): string => {
  if (displayName) {
    return displayName;
  }
  if (email) {
    return email.split("@")[0];
  }
  return "-";
};
